import React, {Fragment} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Alert, Col, Collapse, Row} from "antd";
import {MARGIN_MD, PADDING_SM, SPAN_HALF} from "../../../../../../styles/constants";
import {BatchedArrayData} from "./utils";

const mapStateToProps = ({
                             config, scenes: {mappingHandler: {mappingSet: {wizard}}}
                         }) => ({
    validateStatus: wizard.validateDatasetStatus,
    maxRowsErrorMappingValidation: config.dataManagement.maxRowsErrorMappingValidation,
});

const ValidationErrorItem = ({errorType, data}) => {
    if (errorType === "TextFormatErrors") {
        return (
            <div>
                {data.map(item => (
                    <Fragment>
                        <span>{item.componentId}</span>
                        <ul>
                            {item.valuesErrors.map(err => <li>{err.value}: {err.errors.join(",")}</li>)}
                        </ul>
                    </Fragment>
                ))}
            </div>
        );
    }
    if (!Array.isArray(data)) {
        return Object.keys(data).map((obj, idx) =>
            (
                <span
                    key={idx}>{obj}: {data[obj].join(", ")}</span>
            )
        )
    }
    return (
        <div>
            <span>{data.join(",")}</span>
        </div>
    )
}

const MappingSetValidateDataset = ({t, validateStatus, maxRowsErrorMappingValidation}) => {
    if (!validateStatus) return null
    if (validateStatus.filter(item => !!item.errorMessage).length > 0) {
        return <Alert type="warning"
                      message={<ul>{validateStatus.filter(item => !!item.errorMessage).map(item =>
                          <li>{item.errorMessage}</li>)}</ul>}
                      showIcon/>
    }
    return (
        <Fragment>
            <Alert type="warning"
                   message={t('scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.datasetWarning')}
                   showIcon
                   style={{marginBottom: MARGIN_MD}}
            />
            <Collapse
                className="nodes-config__node"
            >
                {["CodelistErrors", "TextFormatErrors", "HasMissingValue"].map(errorType => {
                    const errorNumber = (validateStatus || []).reduce((acc, curr) => {
                        const currLength = Array.isArray(curr[errorType]) ? curr[errorType].length : Object.keys(curr[errorType]).length;
                        return acc + currLength;
                    }, 0);
                    const filteredData = (validateStatus || []).filter(item => Array.isArray(item[errorType]) ? item[errorType].length : Object.keys(item[errorType]).length);
                    return (
                        (
                            <Collapse.Panel
                                header={`${t(`scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.${errorType}`)} - ${errorNumber}`}
                                key={errorType}
                                disabled={errorNumber === 0}
                            >
                                <BatchedArrayData maxRowsErrorMappingValidation={maxRowsErrorMappingValidation} data={filteredData} t={t} renderData={(item, idx) => (
                                    <Row key={item.dsdColumnName} type="flex" gutter={PADDING_SM}
                                         style={{
                                             borderBottom: idx < filteredData.length - 1 ? "1px solid #e5e5e5" : null,
                                             paddingTop: idx > 0 ? PADDING_SM : null,
                                             paddingBottom: idx < filteredData.length - 1 ? PADDING_SM : null,
                                             width: "100%"
                                         }}>
                                        <Col span={SPAN_HALF} style={{
                                            display: "flex",
                                            gap: PADDING_SM,
                                            flexDirection: "row",
                                            alignItems: "start"
                                        }}>
                                            <Row type="flex" align="middle" style={{width: "100%"}}>
                                                <Col span={SPAN_HALF}>
                                                    <Row type="flex" style={{flexDirection: "column"}}
                                                         gutter={PADDING_SM}>
                                                        <Col>
                                                        <span style={{fontWeight: "bold"}}>
                                                            {t('scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.datasetColumn')}
                                                        </span>
                                                        </Col>
                                                        <Col>
                                                            <span>{item.datasetColumnName}</span>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                                <Col span={SPAN_HALF}>
                                                    <Row type="flex" style={{flexDirection: "column"}}
                                                         gutter={PADDING_SM}>
                                                        <Col>
                                                        <span style={{fontWeight: "bold"}}>
                                                            {t('scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.DSDColumn')}
                                                        </span>
                                                        </Col>
                                                        <Col>
                                                            <span>{item.dsdColumnName}</span>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={SPAN_HALF}>
                                            <Row type="flex" style={{flexDirection: "column"}}
                                                 gutter={PADDING_SM}>
                                                <Col>
                                            <span
                                                style={{fontWeight: "bold"}}>{t(`scenes.mappingHandler.MappingSet.wizard.steps.second.validationAlert.${errorType}`)}</span>
                                                </Col>
                                                <Col>
                                                    <ValidationErrorItem errorType={errorType} data={item[errorType]} />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                )} />
                            </Collapse.Panel>
                        )
                    )
                })}
            </Collapse>
        </Fragment>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps),
)(MappingSetValidateDataset);
